module.exports = __webpack_public_path__ + "img/home-hero_en.587d1b0.jpg";